<template>
    <list-container>
        <template #header>
            <list-cell-header>
                <template #title>
                    Type
                </template>
            </list-cell-header>

            <list-cell-header>
                <template #title>
                    Binnenkomst
                </template>

                <template #subtitle>
                    Laatste update
                </template>
            </list-cell-header>

            <list-cell-header>
                <template #title>
                    Status
                </template>
            </list-cell-header>

            <!-- <list-cell-header>
                <template #title>
                    Aangemaakt
                </template>

                <template #subtitle>
                    Team
                </template>
            </list-cell-header> -->

            <list-cell-header>
                <template #title>
                    Verantwoordelijk
                </template>

                <template #subtitle>
                    Team
                </template>
            </list-cell-header>

            <list-cell-header />
        </template>

        <template #content>
            <list-row v-for="order in filteredOrders" :key="order.id">
                <list-cell-text>
                    <template #content>
                        <text-decorator bold>
                            {{ labelForType(order.type) }}
                        </text-decorator>
                    </template>
                </list-cell-text>

                <list-cell-created-updated
                    :created-at="order.createdAt"
                    :updated-at="order.updatedAt"
                />

                <list-cell-dot :color="colorForStatus(order.status)">
                    <template #title>
                        {{ labelForStatus(order.status) }}
                    </template>
                </list-cell-dot>

                <!-- <list-cell-avatar :placeholder="order.
                    createdBy.name.substring(0, 2).toUpperCase()">
                    <template #title>
                        {{ entry.createdBy }}
                    </template>

                    <template #subtitle>
                        {{ entry.createdByTeam }}
                    </template>
                </list-cell-avatar> -->

                <list-cell-avatar
                    :placeholder="order.assignedTo?.name.substring(0, 2).toUpperCase() ?? '??'"
                >
                    <template #title>
                        {{ order.assignedTo?.name }}
                    </template>

                    <template #subtitle>
                        {{ order.assignedToBranch?.name }}
                    </template>
                </list-cell-avatar>

                <list-cell-action-open @click="openOrder(order.id)" />
            </list-row>
        </template>
    </list-container>

    <list-footer>
        <template #default>
            <contact-create-order-collapse>
                Nieuwe opdracht aanmaken
            </contact-create-order-collapse>
        </template>
        <template #right>
            <list-footer-action-show-more
                v-if="availableOrders.length > 3"
                @click="viewAll = !viewAll"
            >
                <template v-if="viewAll">
                    Bekijk minder
                </template>
                <template v-else>
                    Bekijk alle {{ availableOrders.length }}
                </template>
            </list-footer-action-show-more>
        </template>
    </list-footer>
</template>

<script setup lang="ts">
    import {
        Color,
        ListFooter,
        TextDecorator,
        ListContainer,
        ListCellHeader,
        ListCellDot,
        ListRow,
        ListCellText,
        ListCellAvatar,
        ListCellActionOpen,
        ListFooterActionShowMore,
    } from '@keyvue/one-ui';

    import ListCellCreatedUpdated from '@components/List/Cells/ListCellCreatedUpdated.vue';
    import { computed, inject, type Ref, ref } from 'vue';
    import type { Order } from '@keyvue/one-api-client-legacy';
    import type { Contact } from '@keyvue/one-api-client';
    import { useRouter } from 'vue-router';
    import ContactCreateOrderCollapse from '@components/Collapses/ContactCreateOrderCollapse.vue';

    const contact = inject<Contact>('contact');
    if (!contact) throw new Error('contact is not provided');

    const orders = inject<Ref<Order[]>>('orders');
    if (!orders) throw new Error('No orders provided');
    const availableOrders = computed(() => orders.value);
    const filteredOrders = computed(() => (viewAll.value ? availableOrders.value : availableOrders.value.slice(0, 3)));
    const viewAll = ref(false);

    const labelForType = (type: string): string => {
        switch (type) {
        case 'purchase':
            return 'Aankoop';
        case 'sale':
            return 'Verkoop';
        case 'mortgage':
            return 'Hypotheek';
        case 'rental':
            return 'Verhuur';
        default:
            return 'Onbekend type';
        }
    };

    const labelForStatus = (status: string): string => {
        switch (status) {
        case 'pending':
            return 'In behandeling';
        case 'successful':
            return 'Succesvol afgerond';
        case 'unsuccessful':
            return 'Niet succesvol afgerond';
        default:
            return 'Onbekende status';
        }
    };

    const colorForStatus = (status: string): Color => {
        switch (status) {
        case 'pending':
            return Color.gray300;
        case 'successful':
            return Color.green500;
        case 'unsuccessful':
            return Color.red500;
        default:
            return Color.gray300;
        }
    };

    const router = useRouter();
    const openOrder = (id: string) => {
        router.push({
            name: 'contactOrderDetail',
            params: {
                contactId: contact.id.toString(),
                orderId: id.toString(),
            },
        });
    };
</script>
